import React from 'react';
import { useTranslation } from 'react-i18next';
import './Button.scss';

export type ButtonTheme = 'link' | 'primary' | 'link primary' | 'default' | 'default primary' | 'danger' | 'link danger';

type ButtonPropsType = {
    title: string
    children?: React.ReactNode | React.ReactNode[]
    type?: 'button' | 'submit' | 'reset',
    theme?: ButtonTheme,
    className?: string
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void,
    disabled?: boolean
    name?: string
}
const Button = (props: ButtonPropsType) => {
    const [t] = useTranslation();
    const className = `${props.className || ''} ${props.theme || 'default'} btn cursor-pointer`.trim();
    let title = props.title + '';
    if(props.title.indexOf('.') > -1) {
        title = t(title)
    }
    return (
        <button name={props.name} type={props.type || 'button'} disabled={props.disabled} title={title} className={className} onClick={props.onClick}>
            {props.children}
        </button>
    );
};
export default Button;
